import { render, staticRenderFns } from "./URLhaus.vue?vue&type=template&id=2fb17c28&"
import script from "./URLhaus.vue?vue&type=script&lang=js&"
export * from "./URLhaus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports